import { render, staticRenderFns } from "./UniversityUsers.vue?vue&type=template&id=77990e68&scoped=true&"
import script from "./UniversityUsers.vue?vue&type=script&lang=js&"
export * from "./UniversityUsers.vue?vue&type=script&lang=js&"
import style0 from "./UniversityUsers.vue?vue&type=style&index=0&id=77990e68&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77990e68",
  null
  
)

export default component.exports